"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { House, Hammer, ClipboardCheck } from "lucide-react";
export default function ServiceOfferings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    icon: House,
    title: "Full Custom House Building",
    description: "From concept to completion, we manage every phase of your custom home build with hands-on guidance and direct communication."
  }, {
    id: 2,
    icon: Hammer,
    title: "Timber-Frame Residences",
    description: "Specializing in timber-frame construction, we bring warmth and character to your home while ensuring structural integrity and long-term performance."
  }, {
    id: 3,
    icon: ClipboardCheck,
    title: "Design-to-Completion Project Management",
    description: "We lead every project phase, ensuring thoughtful decisions, clean job sites, and a calm, transparent partnership throughout the build."
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6">
        <div ref={ref} className={`grid gap-8 md:grid-cols-3 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className="group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium border border-border bg-muted/40">
                <CardHeader className="space-y-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-md bg-primary/10">
                    <IconComponent className="size-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {service.description}
                  </p>
                  <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary-hover transition-all duration-[var(--duration-medium)] hover:scale-[1.02] underline underline-offset-4">
                    
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
      <div className="container mx-auto px-6 mt-16">
        <div className="h-px bg-border/50" />
      </div>
    </section>;
}